import React from "react";
import { useNavigate } from "react-router-dom";

const Projects: React.FC = () => {
  const navigate = useNavigate();

  const projects = [
    {
      image: "/palm_threshing_machine.png",
      alt: "Welding Project 1",
    },
    {
      image: "/palm_kenel_oil_machines.png",
      alt: "Welding Project 2",
    },
    {
      image: "/drying_machine.png",
      alt: "Welding Project 3",
    },
    {
      image: "/project4.png",
      alt: "Welding Project 4",
    },
    {
      image: "/pasturizer.png",
      alt: "Welding Project 5",
    },
    {
      image: "/project6.png",
      alt: "Welding Project 6",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Our Projects</h2>
          <p className="text-gray-600">
            The smartest working shop in the steel business
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-md"
            >
              <div className="aspect-w-4 aspect-h-3">
                <img
                  src={project.image}
                  alt={project.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <button className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors transform -translate-y-2 group-hover:translate-y-0 duration-300">
                    View Project
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Projects Button */}
        <div className="text-center">
          <button
            onClick={() => navigate("/projects")}
            className="bg-orange-500 text-white px-8 py-3 rounded inline-flex items-center space-x-2 hover:bg-orange-600 transition-colors"
          >
            <span>VIEW ALL PROJECTS</span>
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
